import ButtonGroup from "@/components/layout/forms/ButtonGroup.vue"
import TextInput from "@/components/layout/forms/TextInput.vue"
import TextCurrencyInput from "@/components/layout/forms/TextCurrencyInput.vue"
import SelectInput from "@/components/layout/forms/SelectInput.vue"
import SelectState from "@/components/layout/forms/SelectState.vue"
import LoadingSpinner from "@/components/layout/core/LoadingSpinner.vue"

export const layoutComponents = {
  "button-group": ButtonGroup,
  "text-input": TextInput,
  "text-currency-input": TextCurrencyInput,
  "select-input": SelectInput,
  "select-state": SelectState,
  "loading-spinner": LoadingSpinner
}

export function registerLayoutComponents(app) {
  Object.entries(layoutComponents).forEach(([name, comp]) => {
    app.component(name, comp)
  })
}
